import { render, staticRenderFns } from "./BaseCardTitle.vue?vue&type=template&id=6f67601a&scoped=true&"
import script from "./BaseCardTitle.vue?vue&type=script&lang=js&"
export * from "./BaseCardTitle.vue?vue&type=script&lang=js&"
import style0 from "./BaseCardTitle.vue?vue&type=style&index=0&id=6f67601a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f67601a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCardTitle,VDivider,VIcon})
